import { render, staticRenderFns } from "./memberAward.vue?vue&type=template&id=0a1aa27d&"
import script from "./memberAward.vue?vue&type=script&lang=js&"
export * from "./memberAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1aa27d')) {
      api.createRecord('0a1aa27d', component.options)
    } else {
      api.reload('0a1aa27d', component.options)
    }
    module.hot.accept("./memberAward.vue?vue&type=template&id=0a1aa27d&", function () {
      api.rerender('0a1aa27d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/memberAward.vue"
export default component.exports